export default "__VITE_ASSET__1x06aVIc__"